import React from "react";
import {
  Slider,
  FormControl,
  FormHelperText,
  type SliderProps,
} from "@mui/material";

interface RangeProps extends Omit<SliderProps, "value" | "onChange"> {
  field: {
    value: number;
    onChange: (value: number) => void;
    name?: string;
    onBlur?: () => void;
  };
  min?: number;
  max?: number;
  step?: number;
  error?: boolean;
  showRange?:boolean;
  helperText?: string | undefined;
  label?:string | undefined;
}

const Range: React.FC<RangeProps> = ({
  field,
  min = 0,
  max = 100,
  step = 1,
  error = false,
  showRange = true,
  helperText,
  label,
  ...rest
}) => {
  const numbers = Array.from(
    { length: Math.floor((max - min) / step) + 1 },
    (_, i) => min + i * step
  );

  const value = field.value ?? min;

  return (
    <FormControl error={error} fullWidth>
      <p>{label}</p>
      <div>
        <Slider
          {...rest}
          value={value}
          min={min}
          max={max}
          step={step}
          onChange={(_, value) => field.onChange(value as number)}
          onBlur={field.onBlur}
        />

        <div>
          
          {showRange && numbers.map((num) => (
            <span
              key={num}
              onClick={() => field.onChange(num)}
              style={{
                cursor: "pointer",
                fontWeight: value === num ? 600 : 400,
                marginRight: 8,
              }}
            >
              {num}
            </span>
          ))}
        </div>
      </div>

      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default Range;